import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDropdownOptions, getInProgress, getVisible } from '../selectors';
import { getMode, getSelected } from '../../finder/selectors';
import { Button, Modal, Select } from '@myua/kit';
import * as tagBinderActions from '../actions';
import '../styles.scss';
import { Page } from '../../router/model';

export const BindTagsModal = () => {
  const dispatch = useDispatch();
  const visible = useSelector(getVisible);
  const inProgress = useSelector(getInProgress);
  const options = useSelector(getDropdownOptions);
  const assetIds = useSelector(getSelected).ids;
  const mode = useSelector(getMode);
  const [tagIds, setTagIds] = useState([]);

  useEffect(() => {
    if (!visible) {
      setTagIds([]);
    }
  }, [visible]);

  const submit = () => {
    if (!inProgress) {
      dispatch(
        tagBinderActions.submitted({
          tagIds,
          assetIds,
          selectAll: assetIds.length === 0 && mode === Page.viewer,
        }),
      );
    }
  };

  const cancel = () => {
    if (!inProgress) {
      dispatch(tagBinderActions.setVisible({ visible: false }));
    }
  };

  return (
    <Modal
      title="Add tags"
      centered
      open={visible}
      keyboard={false}
      maskClosable={false}
      onCancel={cancel}
      footer={
        <>
          <Button onClick={cancel}>Cancel</Button>
          <Button
            type="primary"
            loading={inProgress}
            disabled={tagIds.length === 0}
            onClick={submit}
          >
            OK
          </Button>
        </>
      }
    >
      <Select
        className="al-tag-binder-select"
        mode="multiple"
        allowClear
        placeholder="Select tags"
        optionFilterProp="label"
        options={options}
        value={tagIds}
        onChange={(value) => setTagIds(value)}
      />
    </Modal>
  );
};
